export default {
    "title":" Xo so Online - 6X36 | Xổ số Online",
    "canonical":"st",
    "description":"Đặt mua Xổ số Online trực tuyến, mua loto so xo online trên ứng dụng di dộng với vé số in từ máy chính quy hợp pháp nhà nước của công ty Xổ số Việt!",
    "keyword":"vietlott, mua vé, vé số, mua hộ, trúng thưởng, mega, power, keno, xổ số, điện toán, miễn phí, nhanh chóng, tỷ phú",
    "url":"https://xoso-app.vn",
    "thumb":"https://xoso-app.vn/img/logo/logo.png"
}